// src/app/app-routing.module.ts
// CHANGES: Added /dashboard route pointing to DashboardAdminComponent
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LeadsListComponent } from './leads-list/leads-list.component';
import { QueriesListComponent } from './queries-list/queries-list.component';
import { LoginComponent } from './login/login.component';
import { LeadDetailsModalComponent } from './modal/lead-details-modal/lead-details-modal.component';
import { ViewDocumentComponent } from './queries-list/view-document/view-document.component';
import { LeadViewComponent } from './lead-view/lead-view.component';
import { QueriesViewComponent } from './queries-view/queries-view.component';
import { MatterComponent } from './matter/matter.component';
import { ViewlegalmatterComponent } from './matter/legalmatter/viewlegalmatter/viewlegalmatter.component';
import { GroupsComponent } from './groups/groups.component';
import { DownloadDetailsComponent } from './queries-list/download-details/download-details.component';
import { ReviewDetailsComponent } from './queries-list/review-details/review-details.component';
import { SubscriptionViewComponent } from './subscription-view/subscription-view.component';
import { PlanDetailsComponent } from './plan-details/plan-details.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { LawyersListComponent } from './lawyers-list/lawyers-list.component';
import { CorporateListComponent } from './corporate-list/corporate-list.component';
import { ContactusComponent } from './contact-us/contact-us.component';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientHistoryComponent } from './client-history/client-history.component';
import { LawyerHistoryComponent } from './lawyer-history/lawyer-history.component';
import { OtherProductsComponent } from './other-products/other-products.component';
import { LexizLawyerComponent } from './lexiz-lawyer/lexiz-lawyer.component';
import { LexizClientComponent } from './lexiz-client/lexiz-client.component';

// ── NEW IMPORT ───────────────────────────────────────────
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { AppointmentsComponent } from './appointments/appointments.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  { path: 'login', component: LoginComponent },

  // ── NEW: Dashboard route ─────────────────────────────────
  { path: 'dashboard', component: DashboardAdminComponent },

  { path: 'queries', component: QueriesListComponent },
  { path: 'leads/:id', component: LeadViewComponent },
  { path: 'queries/:id', component: QueriesViewComponent },
  { path: 'download-details/:id', component: DownloadDetailsComponent },
  { path: 'review-details/:id', component: ReviewDetailsComponent },
  { path: 'subscription-view', component: SubscriptionViewComponent },
  { path: 'upgrade/:planType', component: SubscriptionPlansComponent },
  { path: 'plan-details', component: PlanDetailsComponent },
  { path: 'leads', component: LeadsListComponent },
  { path: 'groups', component: GroupsComponent },
  { path: 'viewdoc/:id', component: ViewDocumentComponent },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./notifications/notifications.module').then(m => m.NotificationsModule)
  },
  {
    path: 'audit-trails',
    loadChildren: () =>
      import('./audit-trails/audit-trails.module').then(m => m.AuditTrailsModule)
  },

  // Admin Routes
  { path: 'admin/marketing-offers', loadChildren: () => import('./admin/marketing-offers/marketing-offers.module').then(m => m.MarketingOffersModule) },
  { path: 'admin/lexiz-lawyers',   component: LawyersListComponent },
  { path: 'admin/lexiz-lawyers/:lawyerId', component: LawyerHistoryComponent },
  { path: 'admin/lawyer-leads',    component: LexizLawyerComponent },
  { path: 'admin/lexiz-clients',   component: ClientListComponent },
  { path: 'admin/lexiz-clients/:clientId', component: ClientHistoryComponent },
  { path: 'admin/client-leads',    component: LexizClientComponent },
  { path: 'admin/appointments',    component: AppointmentsComponent },
  { path: 'admin/lexiz-corporate', component: CorporateListComponent },
  { path: 'admin/contact-us',      component: ContactusComponent },
  { path: 'admin/other-products',  component: OtherProductsComponent },

  { path: 'matter',       loadChildren: () => import('./matter/matter.module').then(m => m.MatterModule) },
  { path: 'groups',       loadChildren: () => import('./groups/groups.module').then(m => m.GroupsModule) },
  { path: 'relationship', loadChildren: () => import('./relationship/relationship.module').then(m => m.RelationshipModule) },
  { path: 'document',     loadChildren: () => import('./document/document.module').then(m => m.DocumentModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }